<template>
  <v-container
    fluid
    grid-list-md
    pa-0
    ma-2
    style="max-width: calc(100% - 16px)"
  >
    <!-- Modal de eventos -->
    <dialog-eventos v-model="dialog" :events="events"></dialog-eventos>

    <!-- Header -->
    <template>
      <v-layout row ref="header" wrap class="px-1">
        <!-- Filters -->
        <dashboard-filters
          :initial-creditors="selectedCreditors"
          :initial-publics="selectedPublics"
          :initial-approach-types="selectedApproachTypes"
          :initial-firing-type="selectedFiringType"
          :initial-gateway="selectedGateway"
          :initial-range="range"
          @change="onFiltersChange"
          @creditors-list="updateCreditorsIds"
          @gateways-loaded="onGatewaysLoaded"
        ></dashboard-filters>

        <!-- Cards -->
        <v-layout row class="px-1 pt-1 pb-1 w-100">
          <v-flex
            v-for="(card, key) in cards"
            :key="key"
            xs12
            :class="[
              ['notifications', 'localized'].includes(key) ? 'md3' : 'md2',
              key !== 'implantation' ? 'mr-2' : '',
            ]"
          >
            <dashboard-card
              :color="card.color"
              :icon="card.icon"
              :metrics="card.metrics"
              @click.native="scrollMeTo(card.scroll)"
            ></dashboard-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </template>

    <!-- Graphs -->
    <v-layout row wrap ref="graph_container" class="graph_container">
      <v-layout justify-center align-center row v-if="!showGraphs && !loading">
        <v-flex xs12>
          <v-card
            flat
            class="text-xs-center pa-5"
            style="background: transparent"
          >
            <v-icon size="80" color="grey lighten-1" class="mb-3"
              >mdi-chart-bar</v-icon
            >
            <p class="headline grey--text text--darken-1 mb-2">
              Sem dados para gráficos
            </p>
            <p class="subheading grey--text">
              Ajuste os filtros acima e tente novamente
            </p>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout v-if="showGraphs" column class="mx-1" style="padding-bottom: 60px;">
        <dashboard-graph-group
          ref="refPeriodGroup"
          v-if="showPeriodGraph"
          title="Período"
          color="deep-orange"
          variant="darken-4"
          style-class="mt-2"
          @showNumbers="onShowNumbers('periodBar', $event, 'refPeriodGroup')"
          hide-sort-options
        >
          <template #header>
            <v-btn
              style="max-width: fit-content; padding-bottom: 1px"
              class=""
              depressed
              :disabled="!events.length"
              small
              flat
              color="#bf360c"
              @click="dialog = !dialog"
            >
              {{
                events.length ? "Eventos do período" : "sem eventos no período"
              }}
            </v-btn>
          </template>

          <template>
            <v-layout row class="pa-2">
              <v-flex d-flex xs12>
                <chart
                  ref="periodBar"
                  :options="periodOptionsBar"
                  @legendselectchanged="
                    onLegendSelectChanged($event, 'refPeriodGroup', 'periodBar')
                  "
                ></chart>
              </v-flex>
            </v-layout>
            <v-layout v-if="events.length" row justify-end mr-3>
              <p class="caption">
                <b>* </b>Clique
                <b
                  ><a style="text-decoration: underline" @click="dialog = true"
                    >aqui</a
                  ></b
                >
                para ver os eventos do dia
              </p>
            </v-layout>
          </template>
        </dashboard-graph-group>

        <dashboard-graph-group
          ref="refCreditorsGroup"
          v-if="!oneCreditorSelected"
          title="Notificações - Credores"
          color="teal"
          variant="darken-4"
          :style-class="showPeriodGraph ? 'mt-5' : ''"
          :sortOptions="sortOptions"
          :bar-options="notificationCreditorsVBar"
          @showNumbers="
            onShowNumbers(
              'notificationCreditorsVBar',
              $event,
              'refCreditorsGroup',
            )
          "
          @sortChange="
            onSortChange(
              'notificationCreditorsVBar',
              $event,
              'refCreditorsGroup',
            )
          "
        >
          <template>
            <v-layout row class="pa-2">
              <v-flex d-flex style="flex: 0 1 514px; max-width: 514px">
                <chart
                  ref="notificationCreditorsPie"
                  :options="notificationCreditorsPie"
                ></chart>
              </v-flex>
              <v-flex d-flex style="flex: 1 1 0; min-width: 0">
                <chart
                  ref="notificationCreditorsVBar"
                  :options="notificationCreditorsVBar"
                  @legendselectchanged="
                    onLegendSelectChanged(
                      $event,
                      'refCreditorsGroup',
                      'notificationCreditorsVBar',
                    )
                  "
                ></chart>
              </v-flex>
            </v-layout>
          </template>
        </dashboard-graph-group>

        <dashboard-graph-group
          ref="refApproachGroup"
          title="Notificações - Canais"
          color="indigo"
          variant="darken-4"
          style-class="mt-5"
          :sortOptions="sortOptions"
          :bar-options="notificationApproachVBar"
          @showNumbers="
            onShowNumbers(
              'notificationApproachVBar',
              $event,
              'refApproachGroup',
            )
          "
          @sortChange="
            onSortChange('notificationApproachVBar', $event, 'refApproachGroup')
          "
        >
          <template>
            <v-layout row class="pa-2">
              <v-flex d-flex style="flex: 0 1 514px; max-width: 514px">
                <chart
                  ref="notificationApproachPie"
                  :options="notificationApproachPie"
                ></chart>
              </v-flex>
              <v-flex d-flex style="flex: 1 1 0; min-width: 0">
                <chart
                  ref="notificationApproachVBar"
                  :options="notificationApproachVBar"
                  @legendselectchanged="
                    onLegendSelectChanged(
                      $event,
                      'refApproachGroup',
                      'notificationApproachVBar',
                    )
                  "
                ></chart>
              </v-flex>
            </v-layout>
          </template>
        </dashboard-graph-group>

        <dashboard-graph-group
          ref="refPublicsGroup"
          title="Notificações - Públicos"
          color="blue"
          variant="darken-4"
          style-class="mt-5"
          :sortOptions="sortOptions"
          :bar-options="notificationPublicsVBar"
          @showNumbers="
            onShowNumbers('notificationPublicsVBar', $event, 'refPublicsGroup')
          "
          @sortChange="
            onSortChange('notificationPublicsVBar', $event, 'refPublicsGroup')
          "
        >
          <template>
            <v-layout row class="pa-2">
              <v-flex d-flex style="flex: 0 1 514px; max-width: 514px">
                <chart
                  ref="notificationPublicsPie"
                  :options="notificationPublicsPie"
                ></chart>
              </v-flex>
              <v-flex d-flex style="flex: 1 1 0; min-width: 0">
                <chart
                  ref="notificationPublicsVBar"
                  :options="notificationPublicsVBar"
                  @legendselectchanged="
                    onLegendSelectChanged(
                      $event,
                      'refPublicsGroup',
                      'notificationPublicsVBar',
                    )
                  "
                ></chart>
              </v-flex>
            </v-layout>
          </template>
        </dashboard-graph-group>

        <dashboard-graph-group
          ref="refGatewayGroup"
          title="Notificações - Gateway"
          color="blue"
          variant="darken-4"
          style-class="mt-5"
          :sortOptions="sortOptions"
          :bar-options="notificationGatewayVBar"
          @showNumbers="
            onShowNumbers('notificationGatewayVBar', $event, 'refGatewayGroup')
          "
          @sortChange="
            onSortChange('notificationGatewayVBar', $event, 'refGatewayGroup')
          "
        >
          <template>
            <v-layout row class="pa-2">
              <v-flex d-flex style="flex: 0 1 514px; max-width: 514px">
                <chart
                  ref="notificationGatewayPie"
                  :options="notificationGatewayPie"
                ></chart>
              </v-flex>
              <v-flex d-flex style="flex: 1 1 0; min-width: 0">
                <chart
                  ref="notificationGatewayVBar"
                  :options="notificationGatewayVBar"
                  @legendselectchanged="
                    onLegendSelectChanged(
                      $event,
                      'refGatewayGroup',
                      'notificationGatewayVBar',
                    )
                  "
                ></chart>
              </v-flex>
            </v-layout>
          </template>
        </dashboard-graph-group>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import store from "@/store";
import moment from "moment";
import chartData from "./chart-data-v2";

//services
import eventService from "@/services/event";
import strategyPublic from "@/utils/strategy-public";
import strategyNotificationService from "@/services/notification-history";
import notificationDashboardService from "@/services/notification-dashboard";

//components
import DashboardCard from "@/views/dashboard/components/DashboardCard.vue";
import DashboardFilters from "./components/DashboardFilters.vue";
import DashboardGraphGroup from "./components/DashboardGraphGroup.vue";
import DialogEventos from "./components/DialogEventos.vue";

const LOCAL_STORAGE_KEY = "dashboardOptions";

const GRAPH_REFS = [
  "periodBar",
  "notificationCreditorsPie",
  "notificationCreditorsVBar",
  "notificationApproachPie",
  "notificationApproachVBar",
  "notificationPublicsPie",
  "notificationPublicsVBar",
  "notificationGatewayPie",
  "notificationGatewayVBar",
];

const PUBLICS = ["IMPORTED", "UNCHECKED", "CHECKED", "LOCATED"];

const APPROACH_TYPES = [
  "SMS",
  "EMAIL",
  "PUSH",
  "CALL_CELLPHONE",
  "CALL_PHONE",
  "URA_SANITIZATION",
  "ORGANIC",
  "WHATSAPP",
];

const SORT_OPTIONS = [
  { text: "Notificação", value: 0 },
  { text: "Acessos", value: 1 },
  { text: "Logins", value: 2 },
  { text: "Confirmados", value: 3 },
  { text: "Aceitos", value: 4 },
  { text: "Entregues", value: 5 },
  { text: "Visualizados", value: 6 },
  { text: "Taxa de Interesse", value: 7 },
  { text: "Taxa de Login", value: 8 },
  { text: "Taxa de Conversão", value: 9 },
  { text: "Taxa de Implantação", value: 10 },
  { text: "Taxa de Entrega", value: 11 },
  { text: "Taxa de Visualização", value: 12 },
  { text: "CPP", value: 13 },
  { text: "CPL", value: 14 },
];

const DEFAULT_TOTALS = {
  accessed: 0,
  notifications: 0,
  proposals_confirmed: 0,
  proposals_agreed: 0,
  localized: 0,
  deal_viewed: 0,
  notification_cost: 0,
  notifications_delivered: 0,
  avg_potential: 0,
  down_payment_potential: 0,
};

export default {
  data() {
    return {
      loading: false,
      dialog: false,
      events: [],
      today: moment().format("YYYY-MM-DD"),
      // graph options
      showGraphs: false,
      periodOptionsBar: {},
      notificationCreditorsPie: {},
      notificationCreditorsVBar: {},
      notificationApproachPie: {},
      notificationApproachVBar: {},
      notificationPublicsPie: {},
      notificationPublicsVBar: {},
      notificationGatewayPie: {},
      notificationGatewayVBar: {},
      // filters
      moment: {},
      formatDate: "DD/MM",
      range: {
        start: moment().subtract(0, "day").format("YYYY-MM-DD"),
        end: moment().subtract(0, "day").format("YYYY-MM-DD"),
      },
      gateways: [],
      creditorsIds: [],
      selectedPeriod: 7,
      selectedGateway: [],
      selectedPublics: [],
      selectedCreditors: [],
      selectedFiringType: [],
      selectedApproachTypes: [],
      fetchInterval: null,
      // sort
      sortOptions: SORT_OPTIONS,
      // url query
      query: {},
      // cards structure
      cards: {
        notifications: {
          color: "indigo",
          icon: "mdi-message-text",
          metrics: [],
          scroll: "notifications",
        },
        accessed: {
          color: "brown",
          icon: "mdi-mouse",
          metrics: [],
          scroll: "accessed",
        },
        localized: {
          color: "light-green",
          icon: "mdi-account-search",
          metrics: [],
          scroll: "localized",
        },
        interest: {
          color: "teal",
          icon: "mdi-account-check",
          metrics: [],
          scroll: "interest",
        },
        implantation: {
          color: "purple",
          icon: "mdi-briefcase-check",
          metrics: [],
          scroll: "implantation",
        },
      },
    };
  },
  components: {
    DashboardCard,
    DashboardFilters,
    DashboardGraphGroup,
    DialogEventos,
  },
  async created() {
    let vm = this;
    vm.moment = moment;

    this.setChartData();
    this.setFiltersFromQuery();
    this.getNewData();
  },
  mounted() {
    let vm = this;
    this.ajustHeight();
    this.eventListeners = "zoom resize".split(" ").map(function (e) {
      const handler = async () => {
        vm.refreshGraphs();
        await vm.ajustHeight();
      };
      window.addEventListener(e, handler);
      return { event: e, handler };
    });
  },
  beforeDestroy() {
    if (this.eventListeners) {
      this.eventListeners.forEach(({ event, handler }) => {
        window.removeEventListener(event, handler);
      });
    }
  },
  computed: {
    oneCreditorSelected() {
      return this.selectedCreditors && this.selectedCreditors.length === 1;
    },
    showPeriodGraph() {
      return (
        this.range &&
        this.range.start &&
        this.range.end &&
        this.range.start !== this.range.end &&
        this.range.start <= this.today
      );
    },
  },
  methods: {
    setChartData() {
      this.periodOptionsBar = chartData.periodOptionsBar;
      this.notificationCreditorsPie = chartData.notificationCreditorsPie;
      this.notificationCreditorsVBar = chartData.notificationCreditorsVBar;
      this.notificationApproachPie = chartData.notificationApproachPie;
      this.notificationApproachVBar = chartData.notificationApproachVBar;
      this.notificationPublicsPie = chartData.notificationPublicsPie;
      this.notificationPublicsVBar = chartData.notificationPublicsVBar;
      this.notificationGatewayPie = chartData.notificationGatewayPie;
      this.notificationGatewayVBar = chartData.notificationGatewayVBar;
    },

    updateCreditorsIds(creditorsIds) {
      this.creditorsIds = creditorsIds;
    },
    onGatewaysLoaded(gateways) {
      this.gateways = gateways;
    },
    onFiltersChange(payload) {
      this.selectedCreditors = payload.creditors;
      this.selectedPublics = payload.publics;
      this.selectedApproachTypes = payload.approachTypes;
      this.selectedFiringType = payload.firingType;
      this.selectedGateway = payload.gateway;
      this.range = payload.range;
      this.creditorsIds = payload.creditorsIds;
      this.getNewData();
    },
    async getEvents() {
      let creditorIds = this.selectedCreditors;
      if (!creditorIds.length) creditorIds = this.creditorsIds;

      this.loading = true;

      await eventService
        .listPeriod(creditorIds, this.range.start, this.range.end)
        .then((res) => {
          this.events = res.objects;
          this.events.forEach((e) => {
            e.formatedDate = moment(e.event_time).format("DD/MM");
            e.color = "#" + Math.floor(Math.random() * 16777215).toString(16);
          });
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.loading = false;
        });
    },
    refreshGraphs() {
      GRAPH_REFS.forEach((ref) => {
        if (this.$refs[ref]) this.$refs[ref].resize();
      });
    },
    scrollMeTo(refName) {
      let element = this.$refs[refName];
      if (!element) return;
      let top = element.offsetTop;
      let container = this.$refs["graph_container"];
      let header = this.$refs["header"];
      container.scrollTo(0, top - header.offsetHeight);
    },
    async ajustHeight() {
      let container = this.$refs["graph_container"];
      let header = this.$refs["header"];
      if (container)
        container.style.maxHeight = `${
          window.innerHeight - header.offsetHeight - 20
        }px`;
    },
    async getNewData() {
      clearInterval(this.fetchInterval);
      await this.fetchData();
    },
    async setIntervalPulling() {
      this.fetchInterval = setInterval(async () => {
        if (this.$route.path == "/dashboard") await this.fetchData();
      }, 60000);
    },
    async fetchData() {
      this.resetCards();
      this.resetGraphs();

      this.addFiltersToQuery();
      await this.fetchAverange();
      if (this.showPeriodGraph) {
        this.getEvents();
        this.getPeriodBarChart();
      }
    },

    async fetchAverange() {
      if (this.range.start > this.today) {
        this.$store.commit("showSnackbar", {
          message: "Selecione um período válido!",
          color: "error",
        });
      }

      this.loading = true;
      let creditorIds = this.selectedCreditors;
      if (!creditorIds.length) creditorIds = this.creditorsIds;

      try {
        // cancela requisicoes previas em andamento
        notificationDashboardService.abortAverangeRequests();
        notificationDashboardService.abortAverangeDeliveredRequests();

        let response = null;

        response = await notificationDashboardService.fetchAverangeDelivered(
          this.range.start,
          this.range.end,
          creditorIds,
          this.selectedGateway,
          this.selectedPublics,
          this.selectedApproachTypes,
          this.selectedFiringType,
        );

        if (!response || !response.length) {
          response = await notificationDashboardService.fetchAverange(
            this.range.start,
            this.range.end,
            creditorIds,
            this.selectedGateway,
            this.selectedPublics,
            this.selectedApproachTypes,
            this.selectedFiringType,
          );
        }

        if (response && response.length) this.formatData(response);
      } catch (err) {
        if (
          err.name === "CanceledError" ||
          err.name === "AbortError" ||
          err.message === "canceled"
        ) {
          console.error("Requisição cancelada antes de completar");
        } else {
          console.error("Erro na requisição:", err);
        }
      } finally {
        this.loading = false;
      }
    },

    formatData(data) {
      const xAxis = [...new Set(data.map((dt) => dt.creditor_name))];

      this.showGraphs = !!xAxis.length;
      if (!this.showGraphs) return;

      const totals = this.calculateTotals(data, xAxis);
      this.buildCards(totals);

      const totalPerCreditor = this.calculateTotalPerCreditor(data, xAxis);
      this.formatNotificationsCreditors(totalPerCreditor, totals);

      const totalPerPublic = this.calculateTotalPerPublic(data);
      this.formatNotificationsPublics(totalPerPublic, totals);

      const totalPerApproach = this.calculateTotalPerApproach(data);
      this.formatNotificationApproach(totalPerApproach, totals);

      const totalPerGateway = this.calculateTotalPerGateway(data);
      this.formatNotificationGateway(totalPerGateway, totals);

      let vm = this;
      setTimeout(async () => {
        vm.refreshGraphs();
        await vm.ajustHeight();
      }, 100);
    },

    async getPeriodBarChart() {
      if (this.range.start > this.today) return;

      this.loading = true;

      try {
        const params = this.buildPeriodBarChartParams();
        const res = await strategyNotificationService.fetchNotificationBarChart(
          params,
        );

        this.calculatePeriodChart(res.data, res.format);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    buildPeriodBarChartParams() {
      const params = { days: this.selectedPeriod };
      const creditorIds = this.selectedCreditors.length
        ? this.selectedCreditors
        : this.creditorsIds;

      if (this.range.start && this.range.end) {
        params.start_date = this.range.start;
        params.end_date = this.range.end;
      }
      if (this.selectedPublics.length)
        params.strategy_publics = this.selectedPublics.join(",");
      if (creditorIds.length) params.creditors_ids = creditorIds.join(",");
      if (this.selectedGateway.length)
        params.gateway_ids = this.selectedGateway.join(",");
      if (this.selectedApproachTypes.length)
        params.approach_types = this.selectedApproachTypes.join(",");

      return params;
    },

    calculatePeriodChart(data, format) {
      this.periodOptionsBar.series[0].data = data.map((e) => e.accessed);
      this.periodOptionsBar.series[1].data = data.map((e) => e.localized);
      this.periodOptionsBar.series[2].data = data.map(
        (e) => e.proposals_confirmed,
      );
      this.periodOptionsBar.series[3].data = data.map(
        (e) => e.proposals_agreed,
      );
      this.periodOptionsBar.series[4].data = data.map(
        (e) => e.notifications_delivered,
      );
      this.periodOptionsBar.series[5].data = data.map((e) => e.deal_viewed);
      this.periodOptionsBar.series[6].data = data.map((e) => e.notifications);
      this.periodOptionsBar.series[7].data = data.map((e) => e.cpp);
      this.periodOptionsBar.series[8].data = data.map((e) => e.cpl);
      this.periodOptionsBar.series[9].data = data.map(
        (e) => e.implantation_rate,
      );
      this.periodOptionsBar.series[10].data = data.map((e) => e.interest_rate);
      this.periodOptionsBar.series[11].data = data.map((e) => e.accessed_rate);
      this.periodOptionsBar.series[12].data = data.map((e) => e.delivered_rate);
      this.periodOptionsBar.series[13].data = data.map(
        (e) => e.deal_viewed_rate,
      );
      this.periodOptionsBar.xAxis[0].data = data.map((e) => e.period);

      this.periodOptionsBar.xAxis[0].axisLabel = {
        formatter: (value) =>
          this.checkEventDate(value) ? value + "*" : value,
        fontWeight: "bold",
      };

      this.applyOptionsFromLocalStorage("refPeriodGroup", "periodBar");
    },

    checkEventDate(value) {
      let res = false;
      this.events.forEach((e) => {
        if (value == e.formatedDate) res = true;
      });
      return res;
    },
    // --- FORMATAÇÃO DE GRAFICOS -------------------------------------------------------------------------------------------------
    formatNotificationsCreditors(dataPerCreditor = null, totals = null) {
      this.notificationCreditorsVBar.xAxis.data = [];
      this.notificationCreditorsVBar.series.forEach((s) => (s.data = []));

      if (!dataPerCreditor || this.oneCreditorSelected) return;

      const creditors = Object.keys(dataPerCreditor);
      this.buildNotificationsPie(dataPerCreditor, creditors, totals);

      this.notificationCreditorsVBar.xAxis.data = [...creditors];
      creditors.forEach((credor) => {
        this.notificationCreditorsVBar.series[0].data.push(
          dataPerCreditor[credor].notifications,
        );
        this.notificationCreditorsVBar.series[1].data.push(
          dataPerCreditor[credor].accessed,
        );
        this.notificationCreditorsVBar.series[2].data.push(
          dataPerCreditor[credor].localized,
        );
        this.notificationCreditorsVBar.series[3].data.push(
          dataPerCreditor[credor].proposals_confirmed,
        );
        this.notificationCreditorsVBar.series[4].data.push(
          dataPerCreditor[credor].proposals_agreed,
        );
        this.notificationCreditorsVBar.series[5].data.push(
          dataPerCreditor[credor].notifications_delivered,
        );
        this.notificationCreditorsVBar.series[6].data.push(
          dataPerCreditor[credor].deal_viewed,
        );
        this.notificationCreditorsVBar.series[7].data.push(
          dataPerCreditor[credor].accessed_rate,
        );
        this.notificationCreditorsVBar.series[8].data.push(
          dataPerCreditor[credor].login_rate,
        );
        this.notificationCreditorsVBar.series[9].data.push(
          dataPerCreditor[credor].interest_rate,
        );
        this.notificationCreditorsVBar.series[10].data.push(
          dataPerCreditor[credor].implantation_rate,
        );
        this.notificationCreditorsVBar.series[11].data.push(
          dataPerCreditor[credor].delivered_rate,
        );
        this.notificationCreditorsVBar.series[12].data.push(
          dataPerCreditor[credor].deal_viewed_rate,
        );
        this.notificationCreditorsVBar.series[13].data.push(
          dataPerCreditor[credor].cpp,
        );
        this.notificationCreditorsVBar.series[14].data.push(
          dataPerCreditor[credor].cpl,
        );
      });

      this.applyOptionsFromLocalStorage(
        "refCreditorsGroup",
        "notificationCreditorsVBar",
      );
    },

    buildNotificationsPie(data = null, cred = [], totals = {}) {
      this.notificationCreditorsPie.legend.data = [];
      this.notificationCreditorsPie.series[0].data = [];

      if (!data || !cred.length) return;

      const maxItens = 14;
      const maxNameLength = 12;
      let creditors = [...cred];
      let dataPerCreditor = structuredClone(data);

      // se o numero de credores for maior que 14,
      // criamos o item 'Outros' para não quebrar a legenda do grafico
      if (creditors.length > maxItens) {
        const others = creditors.slice(maxItens - 1);
        const othersValue = others.reduce(
          (acc, credor) => acc + dataPerCreditor[credor].notifications,
          0,
        );
        creditors = creditors.slice(0, maxItens - 1);
        creditors.push("Outros");
        dataPerCreditor["Outros"] = { notifications: othersValue };
      }

      // dados:
      creditors.forEach((credor) => {
        this.notificationCreditorsPie.series[0].data.push({
          name: credor,
          value: dataPerCreditor[credor].notifications || 0,
        });
      });

      // legenda:
      this.notificationCreditorsPie.legend.data = [...creditors];
      this.notificationCreditorsPie.legend.formatter = (name) => {
        let shortName = name;

        // reduz nomes grandes na legenda:
        if (name.length > maxNameLength)
          shortName = name.substring(0, maxNameLength) + "...";

        let perc = null;
        if (dataPerCreditor[name])
          perc = this.safeDivide(
            dataPerCreditor[name].notifications,
            totals.notifications || 1,
            100,
          );
        let label = `{name|${shortName}}`;
        if (Number.isFinite(perc))
          label += `{percentColumn|${this.fmtLocaleNumber(perc)}%}`;

        return label;
      };
    },

    formatNotificationApproach(data, totals = {}) {
      this.notificationApproachPie.legend.data = [];
      this.notificationApproachPie.series[0].data = [];
      this.notificationApproachVBar.xAxis.data = [];
      this.notificationApproachVBar.series.forEach((s) => (s.data = []));

      Object.keys(data).forEach((type) => {
        if (!data[type].notifications) return;

        // pie:
        this.notificationApproachPie.series[0].data.push({
          name: type,
          value: data[type].notifications,
        });
        this.notificationApproachPie.legend.data.push(type);

        // bar:
        this.notificationApproachVBar.xAxis.data.push(type);
        this.notificationApproachVBar.series[0].data.push(
          data[type].notifications,
        );
        this.notificationApproachVBar.series[1].data.push(data[type].accessed);
        this.notificationApproachVBar.series[2].data.push(data[type].localized);
        this.notificationApproachVBar.series[3].data.push(
          data[type].proposals_confirmed,
        );
        this.notificationApproachVBar.series[4].data.push(
          data[type].proposals_agreed,
        );
        this.notificationApproachVBar.series[5].data.push(
          data[type].notifications_delivered,
        );
        this.notificationApproachVBar.series[6].data.push(
          data[type].deal_viewed,
        );
        this.notificationApproachVBar.series[7].data.push(
          data[type].accessed_rate,
        );
        this.notificationApproachVBar.series[8].data.push(
          data[type].login_rate,
        );
        this.notificationApproachVBar.series[9].data.push(
          data[type].interest_rate,
        );
        this.notificationApproachVBar.series[10].data.push(
          data[type].implantation_rate,
        );
        this.notificationApproachVBar.series[11].data.push(
          data[type].delivered_rate,
        );
        this.notificationApproachVBar.series[12].data.push(
          data[type].deal_viewed_rate,
        );
        this.notificationApproachVBar.series[13].data.push(data[type].cpp);
        this.notificationApproachVBar.series[14].data.push(data[type].cpl);
      });

      // adicionando porcentagem na legenda:
      this.notificationApproachPie.legend.formatter = (name) => {
        let perc = null;

        if (data[name])
          perc = this.safeDivide(
            data[name].notifications,
            totals.notifications || 1,
            100,
          );

        let label = `{name|${name}}`;
        if (Number.isFinite(perc))
          label += `{percentColumn|${this.fmtLocaleNumber(perc)}%}`;

        return label;
      };

      // ajustando espaço entre legenda e porcentagem:
      this.notificationApproachPie.legend.textStyle.rich.name.width = 75;

      this.applyOptionsFromLocalStorage(
        "refApproachGroup",
        "notificationApproachVBar",
      );
    },

    formatNotificationGateway(data, totals = {}) {
      this.notificationGatewayPie.legend.data = [];
      this.notificationGatewayPie.series[0].data = [];
      this.notificationGatewayVBar.xAxis.data = [];
      this.notificationGatewayVBar.series.forEach((s) => (s.data = []));

      Object.keys(data).forEach((type) => {
        if (!data[type].notifications) return;

        // pie:
        this.notificationGatewayPie.series[0].data.push({
          name: type,
          value: data[type].notifications,
        });
        this.notificationGatewayPie.legend.data.push(type);

        // bar:
        this.notificationGatewayVBar.xAxis.data.push(type);
        this.notificationGatewayVBar.series[0].data.push(
          data[type].notifications,
        );
        this.notificationGatewayVBar.series[1].data.push(data[type].accessed);
        this.notificationGatewayVBar.series[2].data.push(data[type].localized);
        this.notificationGatewayVBar.series[3].data.push(
          data[type].proposals_confirmed,
        );
        this.notificationGatewayVBar.series[4].data.push(
          data[type].proposals_agreed,
        );
        this.notificationGatewayVBar.series[5].data.push(
          data[type].notifications_delivered,
        );
        this.notificationGatewayVBar.series[6].data.push(
          data[type].deal_viewed,
        );
        this.notificationGatewayVBar.series[7].data.push(
          data[type].accessed_rate,
        );
        this.notificationGatewayVBar.series[8].data.push(data[type].login_rate);
        this.notificationGatewayVBar.series[9].data.push(
          data[type].interest_rate,
        );
        this.notificationGatewayVBar.series[10].data.push(
          data[type].implantation_rate,
        );
        this.notificationGatewayVBar.series[11].data.push(
          data[type].delivered_rate,
        );
        this.notificationGatewayVBar.series[12].data.push(
          data[type].deal_viewed_rate,
        );
        this.notificationGatewayVBar.series[13].data.push(data[type].cpp);
        this.notificationGatewayVBar.series[14].data.push(data[type].cpl);
      });

      const maxNameLength = 12;

      // adicionando porcentagem na legenda:
      this.notificationGatewayPie.formatter = (name) => {
        let perc = null;
        let shortName = name;
        // reduz nomes grandes na legenda:
        if (name.length > maxNameLength)
          shortName = name.substring(0, maxNameLength) + "...";

        if (data[name])
          perc = this.safeDivide(
            data[name].notifications,
            totals.notifications || 1,
            100,
          );

        let label = `{name|${shortName}}`;
        if (perc) label += `{percentColumn|${this.fmtLocaleNumber(perc)}%}`;

        return label;
      };

      // ajustando espaço entre legenda e porcentagem:
      this.notificationGatewayPie.legend.textStyle.rich.name.width = 87;

      this.applyOptionsFromLocalStorage(
        "refGatewayGroup",
        "notificationGatewayVBar",
      );
    },

    formatNotificationsPublics(result, totals = {}) {
      this.notificationPublicsPie.legend.data = [];
      this.notificationPublicsPie.series[0].data = [];
      this.notificationPublicsVBar.xAxis.data = [];
      this.notificationPublicsVBar.series.forEach((s) => (s.data = []));

      this.notificationPublicsPie.tooltip = {
        ...(this.notificationPublicsPie.tooltip || {}),
        formatter: (params) => {
          const name = params && params.name ? params.name : "";
          const translatedName = this.$options.filters.strategyPublic(name);
          const value = params && params.value ? params.value : 0;
          const percent = params && params.percent ? params.percent : 0;

          return `${translatedName} : ${value} (${this.fmtLocaleNumber(
            percent,
          )}%)`;
        },
      };

      Object.keys(result).forEach((publicItem) => {
        if (!result[publicItem].notifications) return;

        const p = result[publicItem];
        // pie:
        this.notificationPublicsPie.series[0].data.push({
          name: publicItem,
          value: p.notifications,
        });
        this.notificationPublicsPie.legend.data.push(publicItem);

        // bar:
        this.notificationPublicsVBar.xAxis.data.push(
          this.$options.filters.strategyPublic(publicItem),
        );
        this.notificationPublicsVBar.series[0].data.push(p.notifications);
        this.notificationPublicsVBar.series[1].data.push(p.accessed);
        this.notificationPublicsVBar.series[2].data.push(p.localized);
        this.notificationPublicsVBar.series[3].data.push(p.proposals_confirmed);
        this.notificationPublicsVBar.series[4].data.push(p.proposals_agreed);
        this.notificationPublicsVBar.series[5].data.push(
          p.notifications_delivered,
        );
        this.notificationPublicsVBar.series[6].data.push(p.deal_viewed);
        this.notificationPublicsVBar.series[7].data.push(p.accessed_rate);
        this.notificationPublicsVBar.series[8].data.push(p.login_rate);
        this.notificationPublicsVBar.series[9].data.push(p.interest_rate);
        this.notificationPublicsVBar.series[10].data.push(p.implantation_rate);
        this.notificationPublicsVBar.series[11].data.push(p.delivered_rate);
        this.notificationPublicsVBar.series[12].data.push(p.deal_viewed_rate);
        this.notificationPublicsVBar.series[13].data.push(p.cpp);
        this.notificationPublicsVBar.series[14].data.push(p.cpl);
      });

      // adicionando porcentagem na legenda:
      this.notificationPublicsPie.legend.formatter = (name) => {
        let perc = null;

        if (result[name])
          perc = this.safeDivide(
            result[name].notifications,
            totals.notifications || 1,
            100,
          );

        let label = `{name|${this.$options.filters.strategyPublic(name)}}`;
        if (Number.isFinite(perc))
          label += `{percentColumn|${this.fmtLocaleNumber(perc)}%}`;

        return label;
      };

      // ajustando espaço entre legenda e porcentagem:
      this.notificationPublicsPie.legend.textStyle.rich.name.width = 87;

      this.applyOptionsFromLocalStorage(
        "refPublicsGroup",
        "notificationPublicsVBar",
      );
    },

    // --- CALCULO -------------------------------------------------------------------------------------------------
    safeDivide(numerator, denominator, multiplier = 1, decimals = 2) {
      if (!denominator || isNaN(numerator) || isNaN(denominator)) return 0;
      const factor = Math.pow(10, decimals);
      return (
        Math.round(((numerator || 0) / denominator) * multiplier * factor) /
        factor
      );
    },

    calculateTotals(data, credores) {
      if (!data || !data.length) return null;

      const totals = { ...DEFAULT_TOTALS };

      data.forEach((dt) => {
        if (credores.includes(dt.creditor_name)) {
          totals.accessed += dt.accessed || 0;
          totals.notifications += dt.notifications || 0;
          totals.proposals_confirmed += dt.proposals_confirmed || 0;
          totals.proposals_agreed += dt.proposals_agreed || 0;
          totals.localized += dt.localized || 0;
          totals.deal_viewed += dt.deal_viewed || 0;
          totals.notification_cost += dt.notification_cost || 0;
          totals.notifications_delivered += dt.notifications_delivered || 0;
          totals.avg_potential += dt.avg_potential || 0;
          totals.down_payment_potential += dt.down_payment_potential || 0;
        }
      });

      totals.accessed_rate = this.safeDivide(
        totals.accessed,
        totals.notifications,
        100,
      );
      totals.cpl = this.safeDivide(totals.notification_cost, totals.localized);
      totals.localized_rate = this.safeDivide(
        totals.localized,
        totals.accessed,
        100,
      );
      totals.deal_viewed_rate = this.safeDivide(
        totals.deal_viewed,
        totals.localized,
        100,
      );
      totals.interest_rate = this.safeDivide(
        totals.proposals_confirmed,
        totals.localized,
        100,
      );
      totals.implantation_rate = this.safeDivide(
        totals.proposals_agreed,
        totals.proposals_confirmed,
        100,
      );
      totals.cpp = this.safeDivide(
        totals.notification_cost,
        totals.proposals_agreed,
      );
      totals.ppp = this.safeDivide(
        totals.avg_potential,
        totals.proposals_agreed,
      );
      totals.cash_cost = this.safeDivide(
        totals.down_payment_potential,
        totals.notification_cost,
      );

      return totals;
    },

    calculateTotalPerCreditor(data, creditors) {
      if (!data || !data.length || this.oneCreditorSelected) return null;

      const result = {};

      creditors.forEach((creditor) => {
        result[creditor] = { ...DEFAULT_TOTALS };
      });

      data.forEach((dt) => {
        const cred = dt.creditor_name;
        if (result[cred]) {
          const t = result[cred];
          t.accessed += dt.accessed || 0;
          t.notifications += dt.notifications || 0;
          t.proposals_confirmed += dt.proposals_confirmed || 0;
          t.proposals_agreed += dt.proposals_agreed || 0;
          t.localized += dt.localized || 0;
          t.deal_viewed += dt.deal_viewed || 0;
          t.notification_cost += dt.notification_cost || 0;
          t.notifications_delivered += dt.notifications_delivered || 0;
          t.avg_potential += dt.avg_potential || 0;
          t.down_payment_potential += dt.down_payment_potential || 0;
        }
      });

      Object.keys(result).forEach((creditor) => {
        const t = result[creditor];
        t.accessed_rate = this.safeDivide(t.accessed, t.notifications, 100);
        t.login_rate = this.safeDivide(t.localized, t.accessed, 100);
        t.interest_rate = this.safeDivide(
          t.proposals_confirmed,
          t.localized,
          100,
        );
        t.implantation_rate = this.safeDivide(
          t.proposals_agreed,
          t.proposals_confirmed,
          100,
        );
        t.cpp = this.safeDivide(t.notification_cost, t.proposals_agreed);
        t.cpl = this.safeDivide(t.notification_cost, t.localized);
        t.deal_viewed_rate = this.safeDivide(t.deal_viewed, t.localized, 100);
        t.delivered_rate = this.safeDivide(
          t.notifications_delivered,
          t.notifications,
          100,
        );
        t.ppp = this.safeDivide(t.avg_potential, t.proposals_agreed);
        t.cash_cost = this.safeDivide(
          t.down_payment_potential,
          t.notification_cost,
        );
      });

      const sortedResult = {};
      Object.entries(result)
        .sort(([, totalsA], [, totalsB]) => {
          return (totalsB.notifications || 0) - (totalsA.notifications || 0);
        })
        .forEach(([creditor, totals]) => {
          sortedResult[creditor] = totals;
        });

      return sortedResult;
    },

    calculateTotalPerPublic(data, publics = [...PUBLICS]) {
      if (!data || !data.length) return null;
      const result = {};

      publics.forEach((publicItem) => {
        result[publicItem] = { ...DEFAULT_TOTALS };
        const p = result[publicItem];

        data.forEach((dt) => {
          if (dt.strategy_public === publicItem) {
            p.accessed += dt.accessed || 0;
            p.notifications += dt.notifications || 0;
            p.proposals_confirmed += dt.proposals_confirmed || 0;
            p.proposals_agreed += dt.proposals_agreed || 0;
            p.localized += dt.localized || 0;
            p.deal_viewed += dt.deal_viewed || 0;
            p.notification_cost += dt.notification_cost || 0;
            p.notifications_delivered += dt.notifications_delivered || 0;
            p.avg_potential += dt.avg_potential || 0;
            p.down_payment_potential += dt.down_payment_potential || 0;
          }
        });

        p.interest_rate = this.safeDivide(
          p.proposals_confirmed,
          p.localized,
          100,
        );
        p.delivered_rate = this.safeDivide(
          p.notifications_delivered,
          p.notifications,
          100,
        );
        p.login_rate = this.safeDivide(p.localized, p.accessed, 100);
        p.accessed_rate = this.safeDivide(p.accessed, p.notifications, 100);
        p.implantation_rate = this.safeDivide(
          p.proposals_agreed,
          p.proposals_confirmed,
          100,
        );
        p.deal_viewed_rate = this.safeDivide(p.deal_viewed, p.localized, 100);
        p.cpl = this.safeDivide(p.notification_cost, p.localized);
        p.cpp = this.safeDivide(p.notification_cost, p.proposals_agreed);
      });

      const sortedResult = {};
      Object.entries(result)
        .sort(([, totalsA], [, totalsB]) => {
          return (totalsB.notifications || 0) - (totalsA.notifications || 0);
        })
        .forEach(([publicItem, totals]) => {
          sortedResult[publicItem] = totals;
        });

      return sortedResult;
    },

    calculateTotalPerApproach(data, approaches = [...APPROACH_TYPES]) {
      if (!data || !data.length) return null;
      const result = {};

      approaches.forEach((approach) => {
        result[approach] = { ...DEFAULT_TOTALS };
        const ap = result[approach];

        data.forEach((dt) => {
          if (dt.approach_type === approach) {
            ap.accessed += dt.accessed || 0;
            ap.notifications += dt.notifications || 0;
            ap.proposals_confirmed += dt.proposals_confirmed || 0;
            ap.proposals_agreed += dt.proposals_agreed || 0;
            ap.localized += dt.localized || 0;
            ap.deal_viewed += dt.deal_viewed || 0;
            ap.notification_cost += dt.notification_cost || 0;
            ap.notifications_delivered += dt.notifications_delivered || 0;
            ap.avg_potential += dt.avg_potential || 0;
            ap.down_payment_potential += dt.down_payment_potential || 0;
          }
        });

        ap.interest_rate = this.safeDivide(
          ap.proposals_confirmed,
          ap.localized,
          100,
        );
        ap.delivered_rate = this.safeDivide(
          ap.notifications_delivered,
          ap.notifications,
          100,
        );
        ap.login_rate = this.safeDivide(ap.localized, ap.accessed, 100);
        ap.accessed_rate = this.safeDivide(ap.accessed, ap.notifications, 100);
        ap.implantation_rate = this.safeDivide(
          ap.proposals_agreed,
          ap.proposals_confirmed,
          100,
        );
        ap.deal_viewed_rate = this.safeDivide(
          ap.deal_viewed,
          ap.localized,
          100,
        );
        ap.cpl = this.safeDivide(ap.notification_cost, ap.localized);
        ap.cpp = this.safeDivide(ap.notification_cost, ap.proposals_agreed);
      });

      const sortedResult = {};
      Object.entries(result)
        .sort(([, totalsA], [, totalsB]) => {
          return (totalsB.notifications || 0) - (totalsA.notifications || 0);
        })
        .forEach(([approach, totals]) => {
          sortedResult[approach] = totals;
        });

      return sortedResult;
    },
    calculateTotalPerGateway(data, gateways = [...this.gateways]) {
      if (!data || !data.length) return null;
      const result = {};

      gateways.forEach((gateway) => {
        result[gateway.name] = { ...DEFAULT_TOTALS };
        const g = result[gateway.name];

        data.forEach((dt) => {
          if (dt.gateway_id === gateway.id) {
            g.accessed += dt.accessed || 0;
            g.notifications += dt.notifications || 0;
            g.proposals_confirmed += dt.proposals_confirmed || 0;
            g.proposals_agreed += dt.proposals_agreed || 0;
            g.localized += dt.localized || 0;
            g.deal_viewed += dt.deal_viewed || 0;
            g.notification_cost += dt.notification_cost || 0;
            g.notifications_delivered += dt.notifications_delivered || 0;
            g.avg_potential += dt.avg_potential || 0;
            g.down_payment_potential += dt.down_payment_potential || 0;
          }
        });

        g.interest_rate = this.safeDivide(
          g.proposals_confirmed,
          g.localized,
          100,
        );
        g.delivered_rate = this.safeDivide(
          g.notifications_delivered,
          g.notifications,
          100,
        );
        g.login_rate = this.safeDivide(g.localized, g.accessed, 100);
        g.accessed_rate = this.safeDivide(g.accessed, g.notifications, 100);
        g.implantation_rate = this.safeDivide(
          g.proposals_agreed,
          g.proposals_confirmed,
          100,
        );
        g.deal_viewed_rate = this.safeDivide(g.deal_viewed, g.localized, 100);
        g.cpl = this.safeDivide(g.notification_cost, g.localized);
        g.cpp = this.safeDivide(g.notification_cost, g.proposals_agreed);
      });

      const sortedResult = {};
      Object.entries(result)
        .sort(([, totalsA], [, totalsB]) => {
          return (totalsB.notifications || 0) - (totalsA.notifications || 0);
        })
        .forEach(([approach, totals]) => {
          sortedResult[approach] = totals;
        });

      return sortedResult;
    },

    // --- QUERYS (URL) -------------------------------------------------------------------------------------------------
    setFiltersFromQuery() {
      this.query = this.$route.query;

      if (this.query && Object.keys(this.query).length == 0) {
        this.query = store.getters.getDashboardFilters;
      }

      if (this.query) {
        if (this.query.start && this.query.end) {
          this.range.start = this.query.start;
          this.range.end = this.query.end;
        }
        if (this.query.days) {
          this.selectedPeriod = parseInt(this.query.days);
        }
        if (this.query.creditors) {
          this.selectedCreditors = this.query.creditors.split(",");
        }
        if (this.query.public) {
          let publicOptions = strategyPublic.strategyPublic;
          this.selectedPublics = this.query.public
            .split(",")
            .filter((p) => publicOptions.some((el) => el.value == p));
        }
        if (this.query.approachTypes) {
          this.selectedApproachTypes = this.query.approachTypes
            .split(",")
            .filter((p) => APPROACH_TYPES.includes(p));
        }
        if (this.query.gateways) {
          this.selectedGateway = this.query.gateways
            .split(",")
            .map((p) => parseInt(p));
        }
        if (this.query.firingType) {
          this.selectedFiringType = this.query.firingType.split(",");
        }
      }
    },

    addFiltersToQuery() {
      var a = moment(this.range.start);
      var b = moment(this.range.end);
      this.query = {};
      if (a.isValid() && b.isValid()) {
        a.diff(b, "days");
        this.query.days = a.diff(b, "days");
        this.query.days = this.query.days ? this.query.days * -1 : 0;
        // this.setDateFormat(this.query.days);
        this.selectedPeriod = this.query.days;
        if (this.range.start && this.range.end) {
          this.query.start = this.range.start;
          this.query.end = this.range.end;
        }
      }
      if (this.selectedCreditors.length) {
        this.query.creditors = this.selectedCreditors.map((id) => id).join(",");
      }
      if (this.selectedPublics.length) {
        this.query.public = this.selectedPublics.map((sp) => sp).join(",");
      }
      if (this.selectedApproachTypes.length) {
        this.query.approachTypes = this.selectedApproachTypes
          .map((sp) => sp)
          .join(",");
      }
      if (this.selectedGateway.length) {
        this.query.gateways = this.selectedGateway.map((id) => id).join(",");
      }
      if (this.selectedFiringType.length) {
        this.query.firingType = this.selectedFiringType.map((t) => t).join(",");
      }
      this.$store.commit("setDashboardFilters", this.query);
      if (this.$route.path == "/dashboard") {
        this.$router.replace({
          name: "Dashboard",
          query: this.query,
        });
      }
    },

    // --- Helpers de formatação -------------------------------------------------------------------------------------------------
    fmtCount(value) {
      return this.$options.filters.numeral(value, "0.[00] a");
    },
    fmtPercent(value) {
      return this.$options.filters.numeral(value, "0.[00]%");
    },
    fmtCurrency(value) {
      return this.$options.filters.numeral(value, "0,0[.]00");
    },
    fmtLocaleNumber(value, decimals = 2) {
      return Number(value || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
      });
    },
    setDateFormat(diff) {
      let start = this.range.start;
      let end = this.range.end;
      this.formatDate = "DD/MM";
      if (moment(start).isSame(end, "day")) {
        this.formatDate = "HH:mm";
        return;
      }
      if (!moment(start).isSame(end, "year") || diff > 365) {
        this.formatDate = "YYYY";
        return;
      }
      if (!moment(start).isSame(end, "month") && diff > 30) {
        this.formatDate = "MM YYYY";
      }
    },

    // --- Opções dos graficos (Local Storage) -------------------------------------------------------------------------------------------------

    async saveOptionsInLocalStorage(groupRef, graphRef) {
      if (!groupRef) return;
      const group = this.$refs[groupRef];
      if (!group) return;

      const options = await this.getOptionsFromLocalStorage();

      options[groupRef] = options[groupRef] || {};
      options[groupRef].selected = this.getSelecteds(graphRef);
      options[groupRef].showNumbers = group.getShowNumbers();
      options[groupRef].sortItem = group.getSortItem() || 0;
      options[groupRef].sortDir = group.getSortDir() || "desc";

      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(options));
    },

    getSelecteds(graphRef) {
      const chartRef = this.$refs[graphRef];
      if (!chartRef || !chartRef.chart) return {};

      const currentOptions = chartRef.chart.getOption();
      if (!currentOptions) return {};

      return currentOptions.legend[0].selected;
    },

    getOptionsFromLocalStorage() {
      const options = localStorage.getItem(LOCAL_STORAGE_KEY);
      return options ? JSON.parse(options) : {};
    },

    applyOptionsFromLocalStorage(groupRef, chartRef) {
      const storageOptions = this.getOptionsFromLocalStorage()[groupRef] || {};

      const showNumbers = !!storageOptions.showNumbers || false;
      const sortItem = storageOptions.sortItem || 0;
      const sortDir = storageOptions.sortDir || "desc";
      const selected = storageOptions.selected || {};

      const applyOptions = () => {
        this.onShowNumbers(chartRef, showNumbers, groupRef);
        this.setSelecteds(chartRef, selected);

        if (chartRef !== "periodBar")
          this.onSortChange(chartRef, { sortItem, sortDir }, groupRef);

        const group = this.$refs[groupRef];
        if (!group) return;

        group.setShowNumbers(showNumbers);

        if (chartRef !== "periodBar") {
          group.setSortItem(sortItem);
          group.setSortDir(sortDir);
        }
        this.triggerLegendChange(chartRef);
      };

      this.$nextTick(applyOptions);
    },

    triggerLegendChange(graphRef = "") {
      // dispara o evento legendselectchanged para atualizar o grafico
      if (!graphRef) return;

      const chartRef = this.$refs[graphRef];
      if (chartRef && chartRef.chart) {
        chartRef.chart.trigger("legendselectchanged", {
          name: "",
          selected: this.getSelecteds(graphRef),
        });
      }
    },

    onLegendSelectChanged(params, groupRef, graphRef) {
      const chartRef = this.$refs[graphRef];
      if (!chartRef) return;

      const options = chartRef.chart.getOption();
      const { axes, gridRight, gridLeft } = this.recalculateYAxisLayout(
        options.yAxis,
        options.series,
        params.selected,
      );

      const newOptions = {
        // mostra/esconde a mensagem de vazio do grafico:
        graphic: [
          {
            id: "empty-message",
            invisible: !!Object.values(params.selected).includes(true),
          },
        ],
        grid: { right: gridRight, left: gridLeft },
        yAxis: axes,
      };

      chartRef.mergeOptions(newOptions);
      this.saveOptionsInLocalStorage(groupRef, graphRef);
    },

    recalculateYAxisLayout(yAxes, series, selected) {
      const AXIS_WIDTH = 85; // largura fixa de um eixo y
      let rightVisible = 0; // Contador para eixos visíveis só do lado direito

      const axes = yAxes.map((yAxis, i) => {
        const show = this.shouldShowYAxis(i, series, selected);
        const isRight = yAxis.position === "right";
        let offset = 0;

        if (show && isRight) {
          // Calcula o offset baseado no número de eixos visíveis do lado direito
          offset = rightVisible * AXIS_WIDTH;
          rightVisible++;
        }
        return { ...yAxis, show, offset };
      });

      // Calcula as margem direita do grid baseado no número de eixos visíveis
      const gridRight =
        rightVisible > 1 ? `${(rightVisible - 1) * AXIS_WIDTH - 30}px` : "0%";

      return { axes, gridRight };
    },

    shouldShowYAxis(yIndex = -1, series = [], legend = {}) {
      // primeiro filtra as series que pertencem ao eixo em questão
      // depois checa se tem alguem ativo na legenda
      return series
        .filter((s) => s.yAxisIndex === yIndex)
        .some((s) => legend[s.name]);
    },

    onSortChange(graphRef, sortData, groupRef) {
      const chartRef = this.$refs[graphRef];
      if (!chartRef || !chartRef.chart) return;

      const currentOptions = chartRef.chart.getOption();
      const xData = [...(currentOptions.xAxis[0].data || [])];
      if (!xData.length) return;

      const allSeriesData = currentOptions.series.map((s) => [
        ...(s.data || []),
      ]);
      const targetData = allSeriesData[sortData.sortItem];
      if (!targetData || !targetData.length) return;

      const asc = sortData.sortDir === "asc";
      const indices = xData.map((_, i) => i);
      indices.sort((a, b) =>
        asc
          ? (targetData[a] || 0) - (targetData[b] || 0)
          : (targetData[b] || 0) - (targetData[a] || 0),
      );

      const sortedSeries = allSeriesData.map((sd) => ({
        data: indices.map((i) => sd[i]),
      }));

      chartRef.mergeOptions({
        xAxis: [{ data: indices.map((i) => xData[i]) }],
        series: sortedSeries,
      });

      this.saveOptionsInLocalStorage(groupRef, graphRef);
    },

    setSelecteds(refName, selected = {}) {
      const chartRef = this.$refs[refName];
      if (!chartRef || !chartRef.chart) return;

      const currentOptions = chartRef.chart.getOption();
      if (!currentOptions) return;

      const currentSelected = currentOptions.legend[0].selected;

      for (const [key, _] of Object.entries(currentSelected)) {
        currentSelected[key] = !!selected[key];
      }

      const isAnySelected = Object.values(currentSelected).includes(true);

      chartRef.mergeOptions({
        legend: [
          {
            ...currentOptions.legend[0],
            selected: currentSelected,
          },
        ],
        graphic: [
          {
            id: "empty-message",
            invisible: isAnySelected,
          },
        ],
      });
    },

    onShowNumbers(graphRef, show, groupRef) {
      if (!graphRef) return;
      const chartRef = this.$refs[graphRef];
      if (!chartRef) return;

      const currentSeries = chartRef.chart.getOption().series || [];
      const seriesUpdate = currentSeries.map(() => ({
        label: { show },
      }));
      chartRef.mergeOptions({ series: seriesUpdate });

      this.saveOptionsInLocalStorage(groupRef, graphRef);
    },

    resetGraphs() {
      for (const graphRef of GRAPH_REFS) {
        const chartRef = this.$refs[graphRef];
        if (!chartRef || !chartRef.chart) continue;

        const currentOptions = chartRef.chart.getOption();
        const mergePayload = {};

        if (currentOptions.xAxis && currentOptions.xAxis.length) {
          mergePayload.xAxis = currentOptions.xAxis.map(() => ({ data: [] }));
        }

        if (currentOptions.series && currentOptions.series.length) {
          mergePayload.series = currentOptions.series.map(() => ({ data: [] }));
        }

        chartRef.mergeOptions(mergePayload);
      }
    },

    // --- Construção dos cards -------------------------------------------------------------------------------------------------
    resetCards() {
      for (const [k, _] of Object.entries(this.cards))
        this.cards[k].metrics = [];
    },

    buildCards(total = null) {
      this.resetCards();

      if (!total) return;

      this.buildCardNotifications(total);
      this.buildCardAccessed(total);
      this.buildCardLocalized(total);
      this.buildCardInterest(total);
      this.buildCardImplantation(total);
    },
    buildCardNotifications(total) {
      const {
        notifications,
        notifications_delivered: delivered,
        notification_cost,
        cash_cost,
      } = total;

      // Notificações enviadas
      this.cards.notifications.metrics.push({
        value: this.fmtCount(notifications),
        label: "Notificações enviadas",
      });
      // Notificações entregues
      this.cards.notifications.metrics.push(
        delivered && notifications
          ? {
              value: this.fmtCount(delivered),
              label: `${this.fmtPercent(delivered / notifications)} entregue`,
            }
          : { value: "", label: "" },
      );
      // Custo de notificação
      this.cards.notifications.metrics.push({
        value: "R$ " + this.fmtCurrency(notification_cost),
        label: isFinite(cash_cost)
          ? this.fmtCurrency(cash_cost) + " CC"
          : "0 CC",
      });
    },
    buildCardAccessed(total) {
      // Taxa de interesse (accessed_rate / 100)
      this.cards.accessed.metrics.push({
        value: this.fmtPercent(total.accessed_rate / 100),
        label: "Interesse",
      });
      // Acessos a plataforma
      this.cards.accessed.metrics.push({});
      this.cards.accessed.metrics.push({
        value: this.fmtCount(total.accessed),
        label: "Acessos a plataforma",
      });
    },
    buildCardLocalized(total) {
      // Taxa de logados (localized_rate / 100)
      this.cards.localized.metrics.push({
        value: this.fmtPercent(total.localized_rate / 100),
        label: "Logados",
      });

      // Contatos logados + CPL
      this.cards.localized.metrics.push({});
      this.cards.localized.metrics.push({
        value: this.fmtCount(total.localized),
        label: `Contatos logados (R$ ${this.fmtCurrency(total.cpl)} CPL)`,
      });

      this.cards.localized.metrics.push({
        value: this.fmtCount(total.deal_viewed),
        label: `${this.fmtPercent(total.deal_viewed_rate / 100)} visualizados`,
      });
    },
    buildCardInterest(total) {
      // Taxa de conversão (interest_rate / 100)
      this.cards.interest.metrics.push({
        value: isFinite(total.interest_rate)
          ? this.fmtPercent(total.interest_rate / 100)
          : this.fmtPercent(0),
        label: "Conversão",
      });
      // Propostas confirmadas
      this.cards.interest.metrics.push({});
      this.cards.interest.metrics.push({
        value: this.fmtCount(total.proposals_confirmed),
        label: "Propostas Confirmadas",
      });
    },
    buildCardImplantation(total) {
      // Taxa de implantação (implantation_rate / 100)
      this.cards.implantation.metrics.push({
        value: this.fmtPercent(total.implantation_rate / 100),
        label: "Implantação",
      });
      // Propostas acordadas + PPP e CPP
      this.cards.implantation.metrics.push({});
      this.cards.implantation.metrics.push({
        value: this.fmtCount(total.proposals_agreed),
        label: `<b>R$ ${this.fmtCurrency(
          total.ppp,
        )} PPP </b>(R$ ${this.fmtCurrency(total.cpp)} CPP)`,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}

.charts div,
.charts .echarts canvas {
  max-width: 100%;
}

.graph_container {
  max-height: 600px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
